<template>
  <span>
    <ul id="pagination-list" v-show="pages.length > 1">
      <li @click="prevPage()" v-if="currentPage > 1">
        <i class="fa fa-angle-right" aria-hidden="true"></i>
      </li>
      <li
        v-for="(page,i) in pages"
        :key="i"
        @click="moveToPage(page)"
        :class="{'pageOn': page === currentPage}"
      >{{page}}</li>
      <li @click="nextPage()" v-if="currentPage != pages.length">
        <i class="fa fa-angle-left" aria-hidden="true"></i>
      </li>
    </ul>
  </span>הגדרות חשבון בנק


</template>
<script>
export default {
  name: "Pagination",
  props: ["data", "nForPage"],
  data() {
    return {
      currentPage: 1,
      data: null,
      pages: [],
      displayRange: []
    };
  },
  methods: {
    nextPage: function() {
      this.currentPage++;
    },
    prevPage: function() {
      this.currentPage--;
    },
    moveToPage: function(page) {
      this.currentPage = page;
    },
    computePages: function() {
      this.pages = [];
      for (
        let i = 1;
        i < Math.ceil(this.data.length / this.nForPage) + 1;
        i++
      ) {
        this.pages.push(i);
      }

      this.displayRange = [];
      for (
        let i = (this.currentPage - 1) * this.nForPage;
        i < this.currentPage * this.nForPage;
        i++
      ) {
        this.displayRange.push(i);
      }

      this.$root.$emit("pageChange", this.currentPage);
      this.$parent.paginate(this.displayRange);
    }
  },
  watch: {
    data: "computePages",
    currentPage: "computePages"
  },
  created() {
    let _this = this;
    this.computePages();
    this.$root.$on("pageChange", function(val) {
      $(document).animate({ scrollTop: "0px" }, 500);
      _this.currentPage = val;
    });
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/style.less";

#pagination-list {
  display: block;
  margin: 15px auto;
  text-align: left;
  user-select: none;
  li {
    user-select: none;
    display: inline-block;
    vertical-align: top;
    padding: 6.5px 12px;
    cursor: pointer;
    transition: all 0.1s;
    &:hover {
      color: @orange;
    }
  }
}

.pageOn {
  color: @background;
  background: @orange;
  &:hover {
    color: @background !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue